import { useMemo } from 'react'

export function useFlowLinks(html: string): string[] {
  return useMemo(() => {
    if (!html) return []
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const anchors = Array.from(doc.querySelectorAll('a[href]'))
    const hrefs = anchors
      .map((a) => a.getAttribute('href') || '')
      .filter((href) => href.startsWith('http'))
    return Array.from(new Set(hrefs))
  }, [html])
}
